export default __webpack_public_path__ + "assets/webgl/complete-15.91e05701.jpg";